// Owner 2026-10-19 (requirement 71, v2.11): thermal label 100×150 mm at the QC computer. No imports (Jest).

export const UKURAN = { lebar: 100, tinggi: 150 };  // mm (Blueprint BP-TD110BT)

// The page CSS for printing one label: exact paper size, no margins, and nothing else on the page. The label
// lives in its own element directly under <body> (#label-cetak, a React portal): in print every other child of
// <body> is display:none, so the output is exactly ONE page (a fixed element would repeat on every page).
export const cssCetak = () =>
  `@page { size: ${UKURAN.lebar}mm ${UKURAN.tinggi}mm; margin: 0; }\n` +
  "@media screen { #label-cetak { position: fixed; left: -10000px; top: 0; } }\n" +
  "@media print { body > *:not(#label-cetak) { display: none !important; }" +
  " #label-cetak { display: block !important; position: static !important; }" +
  " html, body { margin: 0 !important; padding: 0 !important; background: #fff !important; } }";

// The QR holds an INTERNAL link: the SPK page of the app (login required), never the public tracking link.
export function urlQr(origin, nomorSpk) {
  const o = String(origin || "").replace(/\/+$/, "");
  return `${o}/spk?q=${encodeURIComponent(nomorSpk || "")}`;
}

// "452" from "SPK-2026-000452": printed big.
export const nomorPendek = (n) => (String(n || "").split("-").pop() || "").replace(/^0+(?=\d)/, "");

// Jersey sizes in one line: "S 2 · M 5 · L 4".
export const teksUkuran = (ukuran) => (ukuran || []).map((u) => `${u.ukuran} ${u.jumlah}`).join(" · ");

// "Dicetak 2× · terakhir oleh Rina" for the printed tab.
export function infoCetak(l) {
  if (!l || !l.jumlah_cetak) return "Belum dicetak";
  const siapa = l.cetak_terakhir?.oleh?.nama || l.cetak_terakhir?.oleh?.username || "";
  return `Dicetak ${l.jumlah_cetak}×${siapa ? ` · terakhir oleh ${siapa}` : ""}`;
}

export const GRUP = { OUTDOOR: "Outdoor", DTF: "DTF", QC_JERSEY: "QC Jersey" };
